export enum WIKI_ACCESS_LEVEL {
  LITE = "LITE",
  EXPERT = "EXPERT",
}

export type WikiAccessLevel = `${WIKI_ACCESS_LEVEL}`;
